export const DEFAULT_COMPARISON_PERIOD = '5';
